import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface DetailSection {
  id: string;
  label: string;
  icon: string;
  content: string;
}

@Component({
  selector: 'app-challenge-sections',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './challenge-sections.component.html',
  styleUrl: './challenge-sections.component.scss'
})
export class ChallengeSectionsComponent {
  @Input() sections: DetailSection[] = [];
  @Input() expandedSections: Set<string> = new Set();
  @Output() sectionToggle = new EventEmitter<string>();
  @Output() sectionScroll = new EventEmitter<string>();

  toggleSection(sectionId: string): void {
    this.sectionToggle.emit(sectionId);
  }

  scrollToSection(sectionId: string, event: Event): void {
    event.stopPropagation();
    this.sectionScroll.emit(sectionId);
  }

  isSectionExpanded(sectionId: string): boolean {
    return this.expandedSections.has(sectionId);
  }
}


